import { render, staticRenderFns } from "./NtrRegistras.vue?vue&type=template&id=27fb20a0&"
import script from "./NtrRegistras.vue?vue&type=script&lang=js&"
export * from "./NtrRegistras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports